<form [formGroup]="form" (ngSubmit)="save()">
    <h1 mat-dialog-title>Comentarios Servicio/Logística</h1>
    <mat-form-field class="full-width">
        <textarea formControlName="comment" matInput placeholder="Comentario"></textarea>
        <mat-error *ngIf="f.comment.errors && f.comment.errors.required">
            Debe escribir un comentario
        </mat-error>
    </mat-form-field>

    <h1 *ngIf="comments.length > 0" mat-dialog-title>Comentarios anteriores</h1>
    <table>
        <tr *ngFor="let comment of comments">

            <td>
                {{ comment.CreateDate | date:"dd/MM/yyyy" }} - {{ comment.Comment}}
            </td>
        </tr>
    </table>
    <div class="clearfix">
        <div class="pull-right">
            <button [disabled]="saving" mat-button type="submit">Guardar</button>
            <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
        </div>
    </div>
</form>